export enum BookingStatus {
  WAITING_FOR_PAYMENT = "waiting_for_payment",
  EXPIRED = "expired",
  PROCESSING = "processing",
  PAID = "paid",
  CANCELLED = "cancelled",
  REJECTED = "rejected",
  ISSUED = "issued",
  REQUEST_FOR_CANCELLATION = "request_for_cancellation"
}